import { Button } from '@web/components/ui/button';

import { LoaderCircle } from 'lucide-react';
import { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react';

export const ButtonLoading = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement> & {
    onClick: () => void;
    isLoading: boolean;
    variant?:
      | 'default'
      | 'destructive'
      | 'outline'
      | 'secondary'
      | 'ghost'
      | 'link'
      | null;
    children: ReactNode;
  }
>(({ isLoading, onClick, variant, children }, ref) => {
  return (
    <Button
      ref={ref}
      onClick={onClick}
      disabled={isLoading}
      data-loading={isLoading}
      className="group relative disabled:opacity-100"
      variant={variant}
    >
      <span className="group-data-[loading=true]:text-transparent">
        {children}
      </span>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <LoaderCircle
            className="animate-spin"
            size={16}
            strokeWidth={2}
            aria-hidden="true"
          />
        </div>
      )}
    </Button>
  );
});

ButtonLoading.displayName = 'Button';
